<script lang="ts">
  import { copy } from "../lib/stores/copy";
</script>

<div class="flex flex-col items-center text-white font-MrEavesXLSanNarOT text-[20px] mt-4">
  <div class="max-w-[95%] w-[550px] text-left">
    <ul class="ml-[0rem] leading-5 my-[0.5rem]">
      {#each $copy.activisionErrorDetails.reasons as reason}
        <li class="flex flex-row mb-[0.5rem]">
          <div class="pr-[0.5rem] text-[3rem]">•</div>
          <div>{reason}</div>
        </li>
      {/each}
    </ul>
    <p class="leading-none mt-[2rem]">{@html $copy.activisionErrorDetails.contactSupport}</p>
  </div>
</div>